import Input, { HEIGHT, HEIGHT_DENSE } from './Input';
export { HEIGHT, HEIGHT_DENSE };
export default Input;